import { FC } from "react"
import { useTranslation } from "react-i18next"
import { EnvelopeNotificationIcon } from "@/assets"
import styles from "./InviteCard.module.scss"

export const InviteCard: FC = () => {
  const { t } = useTranslation()

  return (
    <div className={styles.InviteCard}>
      <div className={styles.InviteCard_inner}>
        <EnvelopeNotificationIcon className={styles.InviteCard_icon} />
        <div className={styles.InviteCard_title}>
          {t("referrals.details.inviteCard.title")}
        </div>
        <div className={styles.InviteCard_description}>
          {t("referrals.details.inviteCard.description")}
        </div>
      </div>
    </div>
  )
}
